export const formatRamalLabel = (rawName) => {
  if (!rawName || typeof rawName !== 'string') return rawName;
  const match = rawName.match(/^(.*?)\s*(\d+)\s*$/);
  if (!match) return rawName;
  const [, name, number] = match;
  const trimmed = name.trim();
  return trimmed ? `${trimmed}-${number}` : number;
};

export const formatSectorLabel = (rawLabel) => {
  if (!rawLabel || typeof rawLabel !== 'string') return rawLabel;
  const parts = rawLabel.split('-');
  if (parts.length < 3) return rawLabel;
  return parts.slice(2).join('-');
};

export const parseCallerId = (callerid, fallbackNumber) => {
  const fallback = fallbackNumber != null ? String(fallbackNumber) : '';
  if (!callerid || typeof callerid !== 'string') {
    return { name: '', number: fallback };
  }

  const angleMatch = callerid.match(/<\s*([^>]+?)\s*>/);
  let rawAngleValue = angleMatch ? angleMatch[1].trim() : '';
  const numFromAngle = rawAngleValue.match(/\d+/);
  let number = numFromAngle ? numFromAngle[0] : '';
  let beforeAngle = angleMatch
    ? callerid.slice(0, angleMatch.index).trim()
    : callerid.trim();

  if (!number) {
    const tailMatch = beforeAngle.match(/(\d+)\s*$/);
    if (tailMatch) {
      number = tailMatch[1];
    }
  }

  let name = beforeAngle;
  if (number) {
    const stripTail = new RegExp(`[\\s\\-]*${number}\\s*$`);
    name = name.replace(stripTail, '');
  }
  name = name.replace(/[\s\-]+$/, '').trim();

  if (name && /^\d+$/.test(name) && name === number) {
    name = '';
  }

  return { name, number: number || fallback };
};

export const formatEndpointDisplay = ({ name, number }) => {
  if (name && number) return `${name}-${number}`;
  if (number) return number;
  return name || '';
};

export const buildEndpointsIndex = (endpointsList) => {
  if (!Array.isArray(endpointsList)) return {};
  return endpointsList.reduce((acc, cur) => {
    if (!cur || cur.endpoint == null) return acc;
    const parts = parseCallerId(cur.callerid, cur.endpoint);
    acc[`${cur.endpoint}`] = {
      name: parts.name,
      number: parts.number,
      display: formatEndpointDisplay(parts),
      accountcode: cur.tenant
    };
    return acc;
  }, {});
};
